import {
  GraphQLID,
  GraphQLFieldConfig,
  GraphQLNonNull,
  GraphQLInputObjectType
} from 'graphql'
import { Context } from '../shared'
import {
  GenericMutationResponseType,
  GenericMutationResponse
} from '../types/generic-mutation-response'

export interface DeleteVulnerabilityPolicyArgs {
  readonly input: {
    readonly id: string
    readonly organizationID: string
  }
}

export const deleteVulnerabilityPolicyArgType = new GraphQLInputObjectType({
  name: 'DeleteVulnerabilityPolicyArgs',
  description:
    'Parameters that describe a delete vulnerability operation operation',
  fields: () => ({
    id: {
      description: 'The ID of the vulnerability policy being deleted',
      type: new GraphQLNonNull(GraphQLID)
    },
    organizationID: {
      description:
        'The ID of the organization that the vulnerability policy belongs to',
      type: new GraphQLNonNull(GraphQLID)
    }
  })
})

export const deleteVulnerabilityPolicyArgs = {
  input: {
    type: deleteVulnerabilityPolicyArgType
  }
}

export const deleteVulnerabilityPolicy: GraphQLFieldConfig<
  any,
  Context,
  DeleteVulnerabilityPolicyArgs
> = {
  description: 'Delete vulnerability policy',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: deleteVulnerabilityPolicyArgs,
  resolve: async (
    _source,
    args: DeleteVulnerabilityPolicyArgs,
    context: Context
  ): Promise<GenericMutationResponse> => {
    const {
      input: { id, organizationID }
    } = args
    const { connector } = context
    await connector.executeDelete(`/${organizationID}/policy/remediation/${id}`)

    return { _placeholder: true }
  }
}
